import { useEffect, useRef } from 'react';

const TRACKED = new Set([
  'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight',
  'KeyW', 'KeyA', 'KeyS', 'KeyD',
  'Space', 'Enter', 'Escape',
]);

export function useKeyboard(): Set<string> {
  const keys = useRef(new Set<string>()).current;

  useEffect(() => {
    const down = (e: KeyboardEvent) => {
      if (TRACKED.has(e.code)) {
        e.preventDefault();
        keys.add(e.code);
      }
    };
    const up = (e: KeyboardEvent) => keys.delete(e.code);

    window.addEventListener('keydown', down);
    window.addEventListener('keyup', up);
    return () => {
      window.removeEventListener('keydown', down);
      window.removeEventListener('keyup', up);
    };
  }, [keys]);

  return keys;
}
